export default "__VITE_ASSET__CErLhgzD__"